import { cn } from "@/utils/cn";
import React, { useMemo } from "react";

export type Props = {
  label: string;
  subLabel?: string;
  children: React.ReactNode;
  className?: string;
  errorclassname?: string;
  error?:
    | string[]
    | string
    | {
        message: string;
      };
} & (
  | { required: true; isOptional?: never; optionalLabel?: never }
  | { isOptional: true; required?: never; optionalLabel?: string }
  | { required?: false; isOptional?: false; optionalLabel?: string }
);

function InputShell({
  label,
  required = false,
  children,
  error,
  isOptional,
  className,
  errorclassname,
  optionalLabel
}: Props) {
  const optLabel = isOptional ? (optionalLabel ?? " - optional") : null;
  const errorValue = useMemo(() => {
    if (!error) return null;
    if (typeof error === "string") return error;
    if (Array.isArray(error)) return error[0];
    return error.message;
  }, [error]);
  return (
    <div className={cn("space-y-1.5", className)}>
      {label && (
        <label className="block text-[0.75rem] text-xs font-medium leading-[0.875rem] text-[#6D7D96]">
          {label}
          {required && <span className="text-danger-base">*</span>}
          {isOptional && <span className="font-normal italic text-[#6D7D96]">{optLabel}</span>}
        </label>
      )}
      {children}
      {errorValue && (
        <div className={cn("text-sm text-danger-base", errorclassname)}>{errorValue}</div>
      )}
    </div>
  );
}

export default InputShell;
